<div class="order-summary-wrap">
    @if (!isPreviewDetail) {
    <h2>Order Summary</h2>
    }
    @if (modelOrder.type == constants.ORDER_TYPE_SAMPLE_SHORT) {
    <ul>
        <li>
            <div class="summary-label">
                Sample Total <small>(Ex.GST)</small>
            </div>
            <div class="summary-price">
                {{ (modelOrder.quote_summary?.subtotal || 0) | currency:'USD':'symbol' }}
            </div>
        </li>
        <li>
            <div class="summary-label">
                Packaging Price <small>(Inc.GST)</small>
            </div>
            <div class="summary-price">
                {{ (modelOrder.quote_summary?.packaging_price || 0) | currency:'USD':'symbol' }}
            </div>
        </li>
        <li>
            <div class="summary-label">
                Delivery <small>(Inc.GST)</small>
            </div>
            <div class="summary-price">
                {{ (modelOrder.quote_logistic?.delivery_charge || 0) | currency:'USD':'symbol' }}
            </div>
        </li>
        <li class="total-summary">
            <div class="summary-label">
                Final Total <small>(Inc. GST)</small>
            </div>
            <div class="summary-price">
                {{ (modelOrder.quote_summary?.final_total || 0) | currency:'USD':'symbol' }}
            </div>
        </li>
    </ul>
    } @else {
    <ul>
        <!-- RRP AMOUNT -->
        @if (!isPreviewDetail || modelOrder?.type !== constants.ORDER_TYPE_SAMPLE_SHORT) {
        <li>
            <div class="summary-label">
                Total RRP <small>(Ex.GST)</small>
            </div>
            <div class="summary-price">
                @if (isPreviewDetail) {
                {{ (modelOrder?.quote_summary?.total_rrp_amount ? modelOrder.quote_summary.total_rrp_amount : 0) |
                currency:'USD':'symbol' }}
                } @else {
                <!--              {{ (modelOrder?.quote_summary?.rrp_amount ? modelOrder.quote_summary.rrp_amount : 0) | currency : 'USD':'symbol' }}-->
                {{ (modelOrder?.quote_summary?.total_rrp_amount ? modelOrder.quote_summary.total_rrp_amount : 0) |
                currency : 'USD':'symbol' }}
                }
            </div>
        </li>
        }
        <!-- RRP AMOUNT -->
        <!-- TOTAL SURFACE & ACCESSORIES -->
        <li class="accessories-summary">
            <div class="summary-label">
                Total Trade Price <small>(Ex.GST)</small>
            </div>
            <div class="summary-price">
                {{ (modelOrder?.quote_summary?.total_surfaces_and_accessories ?
                modelOrder.quote_summary.total_surfaces_and_accessories : 0) | currency : 'USD':'symbol' }}
            </div>
        </li>
        <!-- TOTAL SURFACE & ACCESSORIES -->
        <!-- PREMIUM ADHESIVE -->
        @if (!modelOrder.disabledTotalAdhesivePrice || isPreviewDetail || isOfflineOrder) {
        <li class="premium-summary">
            <div class="summary-label">
                Total Premium Adhesive <small>(Ex.GST)</small>
                @if (!isPreviewDetail && modelOrder.quote_product?.length >= 1 && hasProductLine) {
                @if (!isDisabledQuoteDetail && !modelOrder?.is_archive && modelOrder?.status?.short_name !==
                constants.QUOTE_EXPIRED_SHORT && (modelOrder?.status?.short_name !==
                constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT || modelOrder?.status?.short_name !==
                constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT) && !isQuoteCancel && !isQuoteUnconverted &&
                !isOrderCancel && !isOrderFromQuote && !isOfflineOrder) {
                <label class="checkbox-item">
                    <input type="checkbox" data-md-icheck [checked]="modelOrder?.is_select_adhesive"
                        [disabled]="modelOrder?.status?.short_name === constants.ORDER_DELIVERD_SHORT || isOfflineQuote"
                        [class.cursor-not-allowed]="modelOrder?.status?.short_name === constants.ORDER_DELIVERD_SHORT || isOfflineQuote"
                        (change)="toggleAdhesiveAndPremiumCalculator($event, constants.CONSUMABLE_CALCULATOR_TYPE_ADHESIVE)" />
                    <span class="checkmark"></span>
                </label>
                } @else {
                @if (!isOfflineOrder) {
                <label class="checkbox-item">
                    <input type="checkbox" data-md-icheck [checked]="modelOrder?.is_select_adhesive" disabled
                        class="cursor-not-allowed" />
                    <span class="checkmark"></span>
                </label>
                }
                }
                }

                <!-- The hint explains the tick beside it, which applies adhesive to every PRODUCT on the
                     record. On a consumables-only record the tick is already hidden (no product to work
                     from), so the hint is hidden with it rather than describing a control that is not
                     there. The row itself stays — it carries the record's value. -->
                @if (!isOfflineOrder && hasProductLine) {
                <img src="/assets/admin/images/info-circle-icon.svg" width="20" height="20" alt="info-circle-icon"
                    class="cursor-pointer" tooltip="Checking this box will apply adhesive to every item in the order"
                    placement="auto" />
                }
            </div>

            <div class="summary-price">
                {{ modelOrder?.quote_summary?.total_premium_adhesive || 0 | currency: 'USD':'symbol' }}
            </div>
        </li>
        }
        <!-- PREMIUM ADHESIVE -->
        <!-- PREMIUM SEALING -->
        @if (!modelOrder.disabledTotalPremiumSealingPrice || isPreviewDetail || isOfflineOrder) {
        <li class="premium-summary">
            <div class="summary-label">
                Total Premium Sealing <small>(Ex.GST)</small>
                @if (!isPreviewDetail && modelOrder.quote_product?.length >= 1 && hasProductLine) {
                @if (!isDisabledQuoteDetail && !modelOrder?.is_archive && modelOrder?.status?.short_name !==
                constants.QUOTE_EXPIRED_SHORT && (modelOrder?.status?.short_name !==
                constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT || modelOrder?.status?.short_name !==
                constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT) && !isQuoteCancel && !isQuoteUnconverted &&
                !isOrderCancel && !isOrderFromQuote && !isOfflineOrder) {
                <label class="checkbox-item">
                    <input type="checkbox" data-md-icheck (change)="toggleAdhesiveAndPremiumCalculator($event)"
                        [checked]="modelOrder?.is_select_premium_sealing"
                        [disabled]="modelOrder?.status?.short_name === constants.ORDER_DELIVERD_SHORT || isOfflineQuote"
                        [class.cursor-not-allowed]="modelOrder?.status?.short_name === constants.ORDER_DELIVERD_SHORT || isOfflineQuote" />
                    <span class="checkmark"></span>
                </label>
                } @else {
                @if (!isOfflineOrder) {
                <label class="checkbox-item">
                    <input type="checkbox" data-md-icheck [checked]="modelOrder?.is_select_premium_sealing" disabled
                        style="cursor: not-allowed;" />
                    <span class="checkmark"></span>
                </label>
                }
                }
                }

                <!-- The hint explains the tick beside it, which applies sealing to every PRODUCT on the
                     record. On a consumables-only record the tick is already hidden (no product to work
                     from), so the hint is hidden with it rather than describing a control that is not
                     there. The row itself stays — it carries the record's value. -->
                @if (!isOfflineOrder && hasProductLine) {
                <img src="/assets/admin/images/info-circle-icon.svg" width="20" height="20" alt="info-circle-icon"
                    class="cursor-pointer" tooltip="Checking this box will apply sealing to every item in the order"
                    placement="auto" />
                }
            </div>

            <div class="summary-price">
                {{ modelOrder?.quote_summary?.total_premium_sealing || 0 | currency: 'USD':'symbol' }}
            </div>
        </li>
        }
        <!-- PREMIUM SEALING -->
        <!-- TRADE DISCOUNT -->
        <li class="discount-summary">
            <div class="summary-label">Trade Discount <small>(Ex.GST)
                    {{ getFormattedDiscount(modelOrder?.quote_summary?.trade_discount_percentage) }}</small></div>
            <div class="summary-price">
                &ndash;{{ (modelOrder?.quote_summary?.trade_discount ? modelOrder.quote_summary.trade_discount : 0) |
                currency : 'USD':'symbol' }}
            </div>
        </li>
        <!-- TRADE DISCOUNT -->
        <!-- ADDITIONAL DISCOUNT -->
        <li class="discount-summary">
            <div class="summary-label">Additional Discount</div>
            <div class="summary-price">
                &ndash;{{ (modelOrder?.quote_summary?.applied_discount ? modelOrder.quote_summary.applied_discount : 0)
                | currency : 'USD':'symbol' }}
            </div>
        </li>
        <!-- ADDITIONAL DISCOUNT -->
        <!-- SUB TOTAL -->
        <li>
            <div class="summary-label">
                {{ modelOrder?.type === constants.ORDER_TYPE_SAMPLE_SHORT ? 'Sample' : 'Sub' }} Total
                <small>(Ex.GST)</small>
            </div>
            <div class="summary-price">
                {{ (modelOrder.quote_summary?.subtotal ? modelOrder.quote_summary.subtotal : 0) | currency :
                'USD':'symbol' }}
            </div>
        </li>
        <!-- SUB TOTAL -->
        <!-- PACKAGING PRICE - USE IN SAMPLE REQUEST ONLY -->
        @if (modelOrder?.type === constants.ORDER_TYPE_SAMPLE_SHORT) {
        <li class="discount-summary">
            <div class="summary-label">
                Packaging Price <small>(Inc.GST)</small>
            </div>
            <div class="summary-price">
                {{ (modelOrder?.quote_summary?.packaging_price ? modelOrder.quote_summary.packaging_price : 0)
                |currency:'USD':'symbol' }}
            </div>
        </li>
        }
        <!-- PACKAGING PRICE - USE IN SAMPLE REQUEST ONLY -->
        <!-- DELIVERY CHARGE -->
        <li>
            <div class="summary-label">
                Delivery Charge
                <small>{{ modelOrder?.type == constants.ORDER_TYPE_SAMPLE_SHORT ? '(Inc. GST)' : '(Ex. GST)' }}</small>

                <!-- FREE DELIVERY — a consumables-only quote/order ships free (no freight weight), so
                     say so rather than leaving a bare $0.00 that reads as an unset charge. Checked
                     first so it wins over the manual/auto/address-required labels below, none of which
                     apply when there is nothing to freight. Mirrors the create screen. -->
                <!-- Gated on !isOfflineOrder as well as the flag: free delivery is OUR rule for a
                     console-raised consumables record, and the badge's tooltip states that rule
                     ("no delivery quote is required and none can be added"). An Unleashed-fed record
                     carries whatever delivery arrangement Unleashed set — today that happens to be
                     $0 on all of them, but asserting our rule over their figure would print "Free
                     Delivery" beside a real charge the moment one arrives. Offline records fall
                     through to the branches below, exactly as they did before this badge existed. -->
                <!-- Only while the charge is genuinely nil. Since 29 Sep 2026 an admin may key a
                     delivery charge on a consumables record, and printing "Free Delivery" beside a
                     real amount would be wrong; a keyed charge falls through to the branches below
                     and renders as the amount. -->
                @if (modelOrder?.is_consumable_order && !isOfflineOrder && !(modelOrder?.quote_summary?.shipping_rate > 0)) {
                <label class="applied-label cursor-pointer" [tooltip]="constants.FREE_DELIVERY_APPLIED_TOOLTIP"
                    placement="auto">{{ constants.FREE_DELIVERY_APPLIED }}</label>
                } @else if (isPreviewDetail) {
                @if (modelOrder?.quote_logistic?.delivery_charge) {
                <label class="applied-label">
                    {{ modelOrder?.quote_logistic?.delivery_charge | currency:'USD':'symbol' }}
                </label>
                }
                } @else {
                @if (isQuote) {
                @if (modelOrder?.currentStatusDetail?.title && !isQuoteAccepted && !isQuoteCancel && !isOrderCancel) {
                <label class="req-label">
                    {{ modelOrder.currentStatusDetail.title }}
                </label>
                } @else {
                @if ((!modelOrder?.quote_address?.[0]?.address_line_1 || modelOrder?.quote_address?.[0]?.address_line_1
                === null) && modelOrder.quote_address?.[0]?.is_warehouse_collection ==
                constants.IS_WAREHOUSE_COLLECTION_NO) {
                <label class="req-label">{{ constants.DELIVERY_ADDRESS_REQUIRED }}</label>
                } @else if (modelOrder?.quote_address?.[0]?.address_line_1 &&
                (modelOrder?.quote_address?.[0]?.in_shipping_zone == constants.IN_SHIPPING_ZONE_NO ||
                (modelOrder?.quote_address?.[0]?.in_shipping_zone == constants.IN_SHIPPING_ZONE_YES &&
                modelOrder?.quote_summary?.is_manual_shipping_rate_change ==
                constants.IS_MANUAL_SHIPPING_RATE_CHANGE_YES) || modelOrder?.quote_summary?.shipping_rate === 0) &&
                modelOrder?.quote_summary?.shipping_rate !== null &&
                modelOrder?.quote_address?.[0]?.shipping_truck_type_id !== null &&
                modelOrder.quote_address?.[0]?.is_warehouse_collection === constants.IS_WAREHOUSE_COLLECTION_NO) {
                <label class="applied-label">{{ constants.MANUAL_DELIVERY_QUOTE_APPLIED }}</label>
                } @else if (modelOrder?.quote_address?.[0]?.address_line_1 && (modelOrder?.quote_summary?.shipping_rate
                == null || modelOrder?.quote_address?.[0]?.shipping_truck_type_id == null) &&
                modelOrder.quote_address?.[0]?.is_warehouse_collection === constants.IS_WAREHOUSE_COLLECTION_NO) {
                <label class="req-label">{{ constants.MANUAL_DELIVERY_QUOTE_REQUIRED }}</label>
                } @else if ((modelOrder?.quote_address?.[0]?.shipping_truck_type_id == 4 ||
                (modelOrder?.quote_address?.[0]?.address_line_1 && modelOrder?.quote_address?.[0]?.in_shipping_zone &&
                modelOrder?.quote_address?.[0]?.in_shipping_zone !== constants.IN_SHIPPING_ZONE_YES &&
                modelOrder?.quote_summary?.shipping_rate !== null)) && modelOrder?.status?.short_name ===
                constants.QUOTE_MANUAL_DELIVERY_QUOTE_ADDED_SHORT &&
                modelOrder.quote_address?.[0]?.is_warehouse_collection === constants.IS_WAREHOUSE_COLLECTION_NO) {
                <label class="applied-label">{{ constants.MANUAL_DELIVERY_QUOTE_ADDED }}</label>
                } @else if (modelOrder?.quote_address?.[0]?.address_line_1 &&
                modelOrder.quote_address?.[0]?.in_shipping_zone === constants.IN_SHIPPING_ZONE_YES &&
                (!modelOrder.quote_summary?.is_manual_shipping_rate_change ||
                modelOrder.quote_summary?.is_manual_shipping_rate_change == constants.IS_MANUAL_SHIPPING_RATE_CHANGE_NO)
                && modelOrder.quote_address?.[0]?.is_warehouse_collection === constants.IS_WAREHOUSE_COLLECTION_NO) {
                <label class="applied-label">{{ constants.AUTO_DELIVERY_QUOTE_APPLIED }}</label>
                } @else if (modelOrder?.quote_address?.[0]?.address_line_1 &&
                modelOrder.quote_address?.[0]?.is_warehouse_collection == constants.IS_WAREHOUSE_COLLECTION_YES) {
                <label class="applied-label">{{ constants.CLIENT_ORGANIZED_ORDER_COLLECTION }}</label>
                }
                }
                } @else {
                @if (modelOrder.quote_address?.[0]?.in_shipping_zone === constants.IN_SHIPPING_ZONE_YES &&
                (!modelOrder.quote_summary?.is_manual_shipping_rate_change ||
                modelOrder.quote_summary?.is_manual_shipping_rate_change == constants.IS_MANUAL_SHIPPING_RATE_CHANGE_NO)
                && modelOrder.quote_address?.[0]?.is_warehouse_collection == constants.IS_WAREHOUSE_COLLECTION_NO) {
                <label class="applied-label">{{ constants.AUTO_DELIVERY_QUOTE_APPLIED }}</label>
                } @else if (((modelOrder.quote_address?.[0]?.in_shipping_zone &&
                modelOrder.quote_address?.[0]?.in_shipping_zone !== constants.IN_SHIPPING_ZONE_YES) ||
                (modelOrder?.quote_summary?.is_manual_shipping_rate_change &&
                modelOrder?.quote_summary?.is_manual_shipping_rate_change ==
                constants.IS_MANUAL_SHIPPING_RATE_CHANGE_YES)) && modelOrder.quote_address?.[0]?.is_warehouse_collection
                == constants.IS_WAREHOUSE_COLLECTION_NO) {
                @if (modelOrder?.quote_summary?.shipping_rate != null && modelOrder?.isDisplayPaymentBtn) {
                <label class="applied-label">{{ constants.MANUAL_DELIVERY_QUOTE_APPLIED }}</label>
                }
                @if (!modelOrder?.isDisplayPaymentBtn) {
                <label class="req-label">{{ constants.MANUAL_DELIVERY_QUOTE_REQUIRED }}</label>
                }
                } @else {
                @if (modelOrder?.quote_address?.length > 0) {
                <label class="applied-label">{{ constants.CLIENT_ORGANIZED_ORDER_COLLECTION }}</label>
                }
                }
                }
                }
            </div>
            <div class="summary-price" [class.price-surcharge]="modelOrder.quote_summary?.shipping_rate == null">
                @if ((modelOrder.quote_summary?.shipping_rate || modelOrder.quote_summary?.shipping_rate === 0) &&
                modelOrder?.isDisplayPaymentBtn) {
                {{ modelOrder.quote_summary.shipping_rate | currency:'USD':'symbol' }}
                } @else {
                TBC
                }
                @if (totalCrates()) {
                <small class="crates-label">
                    {{ totalCrates() }} crate{{ totalCrates() > 1 ? 's' : '' }}
                </small>
                }
            </div>
        </li>
        @if (modelOrder.is_split_delivery) {
        <li>
            <div class="summary-label">
                Additional Delivery Charge <small>(Ex.GST)</small>
            </div>
            <div class="summary-price"
                [class.price-surchage]="modelOrder.quote_summary?.additional_delivery_charge == null">
                {{ (modelOrder.quote_summary?.additional_delivery_charge ||
                modelOrder.quote_summary?.additional_delivery_charge === 0) ?
                (modelOrder.quote_summary.additional_delivery_charge | currency : 'USD' : 'symbol') : 'TBC' }}
            </div>
        </li>
        }
        <!-- DELIVERY CHARGE -->
        <!-- STORAGE FEES -->
        @if (modelOrder?.type === constants.ORDER_TYPE_ORDER_SHORT && !modelOrder?.is_consumable_order) {
        <li>
            <div class="summary-label">
                Storage Fees <small>(Ex.GST)</small>
                @if (!isPreviewDetail) {
                <!-- GC-339: GLOBAL order-level storage-fee checkbox for ALL orders (split & non-split). -->
                <label class="checkbox-item storage-fee-gold">
                    <input type="checkbox" data-md-icheck (change)="toggleStorageFeesCalculator($event)"
                        [checked]="modelOrder?.is_storage_fee_applicable"
                        [disabled]="!checkIfOrderReachedAAW() || modelOrder?.status?.short_name === constants.ORDER_DELIVERD_SHORT || modelOrder?.status?.short_name === constants.ORDER_DELIVERY_DISPATCHED_SHORT"
                        [class.cursor-not-allowed]="!checkIfOrderReachedAAW() || modelOrder?.status?.short_name === constants.ORDER_DELIVERD_SHORT || modelOrder?.status?.short_name === constants.ORDER_DELIVERY_DISPATCHED_SHORT" />
                    <span class="checkmark"></span>
                </label>
                <img src="/assets/admin/images/info-circle-icon.svg" width="20" height="20" alt="info-circle-icon"
                    class="cursor-pointer"
                    [tooltip]="!checkIfOrderReachedAAW() ? 'Storage fees will be calculated once the order reaches Available At Warehouse (AAW) status.' : 'Checking this box will apply storage fees to the order'"
                    placement="auto" />
                }
                <!-- GC-339 Phase 1: manual (admin-fixed) storage fee indicator (display-only). History is
                     opened from the clock button in the SFCD modal, not from this badge. -->
                @if (modelOrder?.is_manual_storage_fee) {
                    <span class="applied-label ms-1"
                          tooltip="Manual storage fee is set. View history from the SFCD modal."
                          placement="auto">Manual Storage Fees Applied</span>
                }
            </div>
            <div class="summary-price">
                <!-- GC-339: single order-level is_storage_fee_applicable for all orders. -->
                @if (modelOrder?.is_storage_fee_applicable) {
                {{ modelOrder?.quote_summary?.storage_fees || 0 | currency: 'USD':'symbol' }}
                } @else {
                <span class="strikethrough">
                    {{ modelOrder?.quote_summary?.storage_fees || 0 | currency: 'USD':'symbol' }}
                </span>
                {{ 0 | currency: 'USD':'symbol' }}
                }
            </div>
        </li>
        }
        <!-- STORAGE FEES -->
        @if (!isPreviewDetail || modelOrder?.type !== constants.ORDER_TYPE_SAMPLE_SHORT) {
        <!-- TAX -->
        <li>
            <div class="summary-label">
                Tax <small>(GST)</small>
            </div>
            <div class="summary-price">
                {{ (modelOrder.quote_summary?.tax_gst ? modelOrder.quote_summary.tax_gst : 0) | currency : 'USD' :
                'symbol' }}
            </div>
        </li>
        <!-- TAX -->
        <!-- APPLIED CREDIT -->
        <li class="discount-summary">
            <div class="summary-label">
                Applied Credit
            </div>
            <div class="summary-price">
                &ndash;{{ (modelOrder.quote_summary?.applied_credit || 0) | currency : 'USD' : 'symbol' }}
            </div>
        </li>
        <!-- APPLIED CREDIT -->
        <!-- TOTAL -->
        <li>
            <div class="summary-label">Total <small>(Inc. GST)</small></div>
            <div class="summary-price">{{ (modelOrder.quote_summary?.total || 0) | currency : 'USD' : 'symbol' }}
            </div>
        </li>
        <!-- TOTAL -->
        <!-- CREDIT CARD SURCHARGES: only when a surcharge was actually recorded (hidden at $0) -->
        @if (+(modelOrder.quote_summary?.credit_card_surcharge || 0) > 0) {
        <li>
            <div class="summary-label">
                Credit Card Surcharge
            </div>
            <div class="summary-price price-surcharge">
                <img src="/assets/admin/images/red-info-circle-icon.svg" width="20" height="20"
                    alt="red-info-circle-icon"
                    [tooltip]="'The applied credit card surcharge consists of a 33 cent transaction fee and a Merchant Service Fee (MSF) of 1.87% for domestic cards and 2.97% for international cards. This charge does not come from GatherCo.'"
                    [container]="'body'" [placement]="'left'" />
                {{ modelOrder.quote_summary?.credit_card_surcharge || 0 | currency : 'USD' : 'symbol' }}
            </div>
        </li>
        }
        <!-- CREDIT CARD SURCHARGES -->
        }
        <!-- ROUNDED OFF -->
        @if (roundedOffAmount !== null) {
        <li class="rounded-off-summary">
            <div class="summary-label">
                Round Off
            </div>
            <div class="summary-price">
                {{ roundedOffAmount | currency:'USD':'symbol' }}
            </div>
        </li>
        }
        <!-- ROUNDED OFF -->
        <!-- FINAL TOTAL -->
        <li class="total-summary">
            <div class="summary-label">
                Final Total <small>(Inc. GST)</small>
            </div>
            <div class="summary-price">
                @if (isPreviewDetail && modelOrder?.type !== constants.ORDER_TYPE_SAMPLE_SHORT) {
                {{ ((modelOrder?.quote_logistic?.delivery_charge ? modelOrder.quote_logistic.delivery_charge +
                (modelOrder?.quote_summary?.final_total ?? 0) + (roundedOffAmount ?? 0) : (modelOrder.quote_summary?.final_total ?? 0) + (roundedOffAmount ?? 0))) |
                currency:'USD':'symbol' }}
                } @else {
                {{ ((+modelOrder.quote_summary?.final_total || 0) + (roundedOffAmount ?? 0)) | currency :
                'USD':'symbol' }}
                }
            </div>
        </li>
        <!-- FINAL TOTAL -->
        <!-- OUTSTANDING BALANCE -->
        @if (modelOrder?.type == constants.ORDER_TYPE_ORDER_SHORT && modelOrder?.finalAmountDue > 0.03) {
        <li class="outstanding-summary">
            <div class="summary-label">
                Outstanding Balance <small>(Inc. GST)</small>
            </div>
            <div class="summary-price">
                {{ modelOrder?.finalAmountDue || 0 | currency:'USD':'symbol' }}
            </div>
        </li>
        }
        <!-- OUTSTANDING BALANCE -->

        <!-- UNSETTLED PAID OVER CHARGE -->
        @if (modelOrder?.unsettledAmount > 0.03) {
        <li class="unsettled-summary">
            <div class="summary-label">
                Overcharge Credit
            </div>
            <div class="summary-price">
                {{ modelOrder.unsettledAmount | currency : "USD" : "symbol" }}
            </div>
        </li>
        }
        <!-- UNSETTLED PAID OVER CHARGE -->
    </ul>
    <!-- BUTTON: VIEW QUOTE & EXPORT INVOICE -->
    @if (!isPreviewDetail && !isQuote && !isOrderCancel) {
    <div class="summary-action">
        @if (!isOfflineOrder) {
        <a [routerLink]="['/quotes/view/',modelOrder.id]" type="button" class="btn">
            View Quote
        </a>
        }
        <button type="button" class="btn line-btn" (click)="exportInvoice(modelOrder)">
            <img src="/assets/admin/images/export-icon.svg" width="16" height="16" alt="export-icon" />
            Export Invoice
        </button>
    </div>
    }
    <!-- BUTTON: VIEW QUOTE & EXPORT INVOICE -->
    <!-- SCHEDULED PAYMENTS -->
    @if (!isPreviewDetail && isQuote && !isHideSlider && !isOrderFromQuote) {
    <h2 class="scheduled-payment-title">Scheduled Payments</h2>
    <ul class="mb-10">
        <li>
            <div class="summary-label">
                Deposit Payment
            </div>
            <div class="summary-price">
                {{ (modelOrder.quote_summary?.deposit_amount || 0) | currency:'USD':'symbol' }}
            </div>
        </li>
        <li>
            <div class="summary-label">
                Final Payment
            </div>
            <div class="summary-price">
                {{ (modelOrder.quote_summary?.final_due_amount || 0) | currency:'USD':'symbol' }}
            </div>
        </li>
    </ul>
    @if (!isHideSlider) {
    <app-slider [quoteID]="modelOrder.id" [exportId]="modelOrder.export_id"
        [quoteSummaryID]="modelOrder.quote_summary?.id" [finalAmount]="Number(modelOrder.quote_summary?.final_total)"
        [sliderValue]="Number(modelOrder.quote_summary?.deposit_amount_percentage)"
        [depositAmount]="Number(modelOrder.quote_summary?.deposit_amount)"
        [finalDueAmount]="Number(modelOrder.final_due_amount)" (paymentChanged)="onPaymentChanged($event)"
        [isDisabled]="modelOrder?.is_archive || modelOrder?.is_expired || isQuoteCancel || isOrderCancel || isQuoteUnconverted"
        (isSliderUpdateLoadingEvent)="isSliderUpdateLoadingEvent($event)"></app-slider>
    }
    }
    <!-- SCHEDULED PAYMENTS -->
    }
</div>
